<template>
    <div style="background: #ffffff;">
        <introduction-title ch-title="合作机会" en-title="COOPERATION" style="padding-top: 0px"></introduction-title>
        <div class="cooperation">
            <div class="li">
                <img src="@/assets/image/home/home-cooper-1.png" />
                <div class="title">生产资源合作</div>
            </div>
            <div class="li">
                <img src="@/assets/image/home/home-cooper-2.png" />
                <div class="title">产品合作</div>
            </div>
        </div>
    </div>
</template>

<script>
    import IntroductionTitle from "@/components/IntroductionTitle.vue";
    export default {
        name: "cooperationOpportunities",
        components: {IntroductionTitle},
    }
</script>

<style scoped>
  .cooperation{
      display: flex;
      justify-content: space-between;
      width: 1100px;
      margin-left: 50px
  }
    .cooperation .li{
        width: 536px;
        height: 254px;
        position: relative;
        cursor: pointer;
    }
  .cooperation .li img{
      width: 100%;
  }
  .cooperation .li .title{
      position: absolute;
      width: 100%;
      height: 60px;
      line-height: 60px;
      bottom: 0;
      background: rgba(52, 52, 52, 0.8);
      border-radius: 0px 0px 10px 10px;
      color: #ffffff;
      font-size: 20px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #FFFFFF;
  }
</style>
